import { StyleSheet } from 'aphrodite/no-important';
import { palettes, spacers } from '@trainline/depot-web/css';

export default StyleSheet.create({
  journeyLeg: {
    display: 'flex',
    border: `1px solid ${palettes.dp_app_border_base}`,
    borderColor: palettes.dp_app_border_base,
    borderRadius: spacers.dp_s8,
    padding: spacers.dp_s12,
    backgroundColor: palettes.dp_app_backdrop_white,
  },
  track: {
    padding: 0,
    margin: 0,
  },
  trackItemGrid: {
    position: 'relative',
    display: 'grid',
    gridTemplateColumns: `${spacers.dp_s24} ${spacers.dp_s80} auto`,
    gap: spacers.dp_s24,
  },
  trackingBoundaryGrid: {
    padding: '0.8125rem', // 13px
  },
  trackItemMarkerContainer: {
    height: '100%',
    width: spacers.dp_s24,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  trackItemMarker: {
    height: '100%',
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
  },
  trackItemDot: {
    zIndex: 1,
    width: spacers.dp_s12,
    height: spacers.dp_s12,
    borderRadius: '100%',
    backgroundColor: palettes.dp_brand_neutral_dim,
    transform: `translateY(0.375rem)`, // 6px
  },
  trackItemPath: {
    position: 'absolute',
    width: '0.1875rem', // 3px
    backgroundColor: palettes.dp_brand_neutral_dim,
  },
  trackItemPathOrigin: {
    height: '75%',
    bottom: 0,
  },
  trackItemPathDestination: {
    height: '0.9375rem', // 15px
    top: 0,
  },
  trackItemTime: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'left',
    gridColumnStart: 2,
    whiteSpace: 'nowrap',
  },
  originTime: {
    marginBottom: spacers.dp_s16,
  },
  trackItemInfo: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    textAlign: 'left',
  },
  trackItemPoint: {
    position: 'absolute',
    borderRadius: '100%',
    width: spacers.dp_s4,
    height: spacers.dp_s4,
    backgroundColor: palettes.dp_app_border_dull,
  },
  journeyTrackCard: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacers.dp_s12,
    border: `1px solid ${palettes.dp_app_border_base}`,
    width: `calc(50% - ${spacers.dp_s24})`,
    borderColor: palettes.dp_app_border_base,
    borderRadius: spacers.dp_s8,
    padding: `0.625rem ${spacers.dp_s24} ${spacers.dp_s24}`,
    backgroundColor: palettes.dp_app_backdrop_white,
  },
  supplementaryText: {
    display: 'flex',
    justifyContent: 'flex-start',
    gap: spacers.dp_s12,
  },
});
